import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogService } from './confirm-dialog.service';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ForceLogoutDialogService } from './force-logout-dialog.service';

@Component({
  selector: 'lib-confirm-dialog-container',
  standalone: true,
  imports: [CommonModule, ConfirmDialogComponent],
  templateUrl: './confirm-dialog-container.component.html',
  styleUrl: './confirm-dialog-container.component.scss',
})
export class ConfirmDialogContainerComponent {
  readonly confirmDialogService = inject(ConfirmDialogService);
  readonly dialogs = this.confirmDialogService.dialogs;
  /** Confirm dialog host olan her uygulamada ForceLogout popup handler'ını ayağa kaldırır */
  private readonly forceLogoutDialogService = inject(ForceLogoutDialogService);
}
